import { render, staticRenderFns } from "./F.vue?vue&type=template&id=2e138254&"
import script from "./F.vue?vue&type=script&lang=js&"
export * from "./F.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e138254')) {
      api.createRecord('2e138254', component.options)
    } else {
      api.reload('2e138254', component.options)
    }
    module.hot.accept("./F.vue?vue&type=template&id=2e138254&", function () {
      api.rerender('2e138254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/configurator/F.vue"
export default component.exports